// extracted by mini-css-extract-plugin
module.exports = {"Form":"SignUpForm_Form__3LvCC","FormElements":"SignUpForm_FormElements__36Sd1"};